import React from "react";
import Footer from "./Footer/Footer";
import Navbar from "./Navbar/Navbar";

type PropsType = {
	children: React.ReactNode;
};
const Layout: React.FC<PropsType> = ({ children }) => {
	return (
		<div className="layout">
			<div className="gandal-container">
				<Navbar />
			</div>
			<main className="gandal-container min-h-normal pt-10">{children}</main>
			<Footer />
		</div>
	);
};

export default Layout;
